import { LangType } from '@sdk/lang/types/LangType';

import plPo from './bin/pl_PL.json';
import enPo from './bin/en_US.json';
import frPo from './bin/fr_FR.json';

export const langs = {
  en: enPo,
  pl: plPo,
  fr: frPo,
};

export const languageOptions = [
  { value: LangType.en, label: 'English' },
  { value: LangType.pl, label: 'Polski' },
  { value: LangType.fr, label: 'French' },
];
